/* eslint-disable i18next/no-literal-string  -- .*/
import { useGetNextPayoutDetailQuery } from '@/affiliate-dashboard/graphql';
import { Drawer } from '@/components/base/drawer';
import { PageHeading } from '@/components/base/page-heading';
import { format } from 'date-fns';
import { useIntl } from 'react-intl';

export function PayoutDetailDrawer({
  payoutId,
  isOpen,
  onClose,
}: {
  payoutId: string;
  isOpen: boolean;
  onClose: () => void;
}): JSX.Element {
  const { data, loading } = useGetNextPayoutDetailQuery({
    variables: { payoutId },
  });
  const payoutDetails = data?.nextPayoutDetail;
  const methodDetails = data?.nextPayoutDetail?.paymentMethodDetails;
  const intl = useIntl();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Drawer
      triggerClassname="cursor-pointer w-full"
      contentClassName="h-[60%]"
      isOpen={isOpen}
      trigger={<></>}
      handleChange={() => {
        onClose();
      }}
    >
      <div className="overflow-y-auto">
        <PageHeading>Payout Detail</PageHeading>
        <div className="flex w-full flex-col divide-y divide-gray-700 [&>*]:py-2">
          <div className="flex w-full flex-col items-start justify-between sm:flex-row">
            <span className="font-bold">Payout ID</span>{' '}
            <span className="text-end">{methodDetails?.id}</span>
          </div>
          <div className="flex w-full flex-col items-start justify-between sm:flex-row">
            <span className="font-bold">Amount</span>
            <span>
              {intl.formatNumber(payoutDetails?.amount ?? 0, {
                style: 'currency',
                currency: 'USD',
              })}
            </span>
          </div>
          {methodDetails?.createdAt && (
            <div className="flex w-full flex-col items-start justify-between sm:flex-row">
              <span className="font-bold">Created At</span>
              <span>
                {format(methodDetails?.createdAt ?? '', 'dd MMM yyyy')}
              </span>
            </div>
          )}

          <div className="flex w-full flex-col items-start justify-between sm:flex-row">
            <span className="font-bold">Payout Method</span>
            <span className="text-end">{methodDetails?.paymentMethod}</span>
          </div>

          <div className="flex w-full flex-col items-start justify-between sm:flex-row">
            <span className="font-bold">User Email</span>
            <span className="text-end">{methodDetails?.user?.email}</span>
          </div>

          <div className="flex w-full flex-col items-start justify-between sm:flex-row">
            <span className="font-bold">Target Address</span>
            <span className="text-end">{methodDetails?.targetAddress}</span>
          </div>

          <div className="flex w-full flex-col items-start justify-between sm:flex-row">
            <span className="font-bold">Metadata</span>
            <span className="text-end">
              {methodDetails?.paymentMethodMetadata}
            </span>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
